import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import TableData from "../../data/TableData";
import Toast from "../extras/Toast";

class TableDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            title: "",
            label_button: " ",
            table: {
                id: '',
                number: 1
            },
            number_error: false,
            index: null,
            sending: false
        };

        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleNumberChange = (event) => {
        let number = update(this.state, {
            table: {
                number: {
                    $set: event.target.value
                }
            }
        });
        this.setState(number);
        if (event.target.value.trim() <= 0) {
            this.setState({number_error: true})
        } else {
            this.setState({number_error: false});
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.table.number <= 0) {
            this.setState({number_error: true});
        } else {
            this.setState({sending: true});
            TableData.update(this.state.table, (res) => {
                if (res !== null && res.hasOwnProperty('id')) {
                        this.refs.toast.show({message: 'Mesa Actualizada!', type: 'success'});
                    this.props.callbackUpdateData(res, this.state.index);
                } else {
                    this.refs.toast.show({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                }
                this.setState({sending: false, open: false});
            });
        }
    };

    handleOpen = (table, index) => {
        this.setState({open: true, table, index});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' open={this.state.open} dimmer='inverted' onClose={this.handleClose}>
                    <Modal.Header>Número de mesa</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input type='number' label='Número' placeholder='Número'
                                                        value={this.state.table.number}
                                                        onChange={this.handleNumberChange}
                                                        error={this.state.number_error}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' labelPosition='left' onClick={this.handleSubmit}
                                content='Actualizar' disabled={this.state.sending} loading={this.state.sending}/>
                    </Modal.Actions>
                </Modal>
                <Toast ref='toast'/>
            </div>
        );
    }
}

export default TableDialog;



// WEBPACK FOOTER //
// ./src/components/my_bisttro/TableDialog.js